<template>
  <div class="my-3">
    <p v-if="lastLoginAt" class="fw-semibold fs-6 text-success ps-0">
        {{ $t('license_report.user_last_login_at') }}: {{ getDateString(lastLoginAt) }}
    </p>

    <div v-if="sideLoading">
      <div id="sideloader" class="spinner"/>
      <span> {{ $t('license_report.username_loading') }}</span>
    </div>
    <div v-else>
        <vue3-datatable
            v-if="selectedUserDataMapped.length > 0"
            ref="resultTable"
            :rows="selectedUserDataMapped"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            height="100%"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >
            <template #issuedAt="row">
                {{ row.value && row.value.issuedAt ? getDateString(row.value.issuedAt) : '' }}
            </template>
            <template #removedAt="row">
                {{ row.value && row.value.removedAt ? getDateString(row.value.removedAt) : '' }}
            </template>
        </vue3-datatable>
    </div>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {userHelper} from '../mixins/UserMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {timeUtils} from '../mixins/TimeUtils'

export default {
    name: "LicenseRightsInspector",
    components: {Vue3Datatable},
    mixins: [restApi, userHelper, timeUtils],
    props: {
        userId: {
            type: Number,
            required: true
        },
        lastLoginAt: {
            type: String,
            required: false,
            default: null
        }
    },
    data: function () {
        return {
            sideLoading: true,
            selectedUserData: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'rolename', title: this.$t('license_report.rights_inspector_role_label'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'info', title: this.$t('license_report.rights_inspector_role_info_label'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'company_name', title: this.$t('common.company'), sort: true, headerClass: 'routa-table-header'},
                {field: 'issuer', title: this.$t('license_report.rights_inspector_role_issuer_label'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'issuedAt', title: this.$t('license_report.rights_inspector_role_issued_label'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'remover', title: this.$t('license_report.rights_inspector_role_remover_label'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'removedAt', title: this.$t('license_report.rights_inspector_role_removed_label'),  sort: true, headerClass: 'routa-table-header'}
            ]
        },
        selectedUserDataMapped() {
            return this.selectedUserData.map(right => {
                let temp = {}
                temp['rolename'] = this.getRoleName(right.role.role)
                temp['company_name'] = right.company.name
                temp['info'] = right.info
                if (right.issued_by != null && right.issued_by.first_name != null && right.issued_by.last_name != null){
                    temp['issuer'] = `${right.issued_by.first_name} ${right.issued_by.last_name}`
                }
                else {
                    temp['issuer'] = 'Undefined'
                }

                if (right.issued_at != null){
                    temp['issuedAt'] = this.isValidDate(right.issued_at) ? right.issued_at : null
                }
                else {
                    temp['issuedAt'] = null
                }

                if(right.removed_by != null && right.removed_by.first_name != null && right.removed_by.last_name != null){
                    temp['remover'] = `${right.removed_by.first_name} ${right.removed_by.last_name}`
                }
                else {
                    temp['remover'] = ''
                }

                if(right.removed_at != null)
                {
                    temp['removedAt'] = this.isValidDate(right.removed_at) ? right.removed_at : null
                }
                else {
                    temp['removedAt'] = ''
                }
                return temp
            })
        }
    },
    mounted: function () {
        this.fetchUser()
    },
    methods: {
        fetchUser: function () {
            this.sideLoading = true
            this.restFetch(this.userUrl + '/' + this.userId, this.handleUserFetched)
        },
        handleUserFetched: function (response) {
            this.selectedUserData = response.data.rights || []
            this.sideLoading = false
        },
        isValidDate(dateString) {
            if (!dateString) return false;
            const date = new Date(dateString);
            return !isNaN(date.getTime()) && date.getFullYear() > 1900;
        },
    }
}

</script>
